import React, { createContext, useState } from "react";
import { useLocation } from "react-router-dom";

export const DocumentSearchContextAPI = createContext();

function DocSearchContext({ children }) {
  const getInitialValue = (key) => {
    const index = filterKeys.indexOf(key);
    return index !== -1 ? filterValues[index] : "";
  };
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const FILTER = searchParams.get("filter" || "") || "";
  const VALUE = searchParams.get("value" || "") || "";
  const filterKeys = FILTER.split(",").filter(Boolean);
  const filterValues = VALUE.split(",").filter(Boolean);
  const [businessType, setBusinessType] = useState(getInitialValue("Business"));
  const [onboardStatus, setOnboardStatus] = useState(getInitialValue("Status"));
  const [location, setLocation] = useState(getInitialValue("Location"));
  const [formId, setFormId] = useState(getInitialValue("Application"));
  const [search, setSearch] = useState(getInitialValue("Search"));
  const [filter, setFilter] = useState({
    Business: getInitialValue("Business"),
    Status: getInitialValue("Status"),
    Location: getInitialValue("Location"),
    Application: getInitialValue("Application"),
    Search: getInitialValue("Search"),
  });
  return (
    <DocumentSearchContextAPI.Provider
      value={{
        search,
        setSearch,
        onboardStatus,
        setOnboardStatus,
        location,
        setLocation,
        formId,
        setFormId,
        businessType,
        setBusinessType,
        filter,
        setFilter,
      }}
    >
      {children}
    </DocumentSearchContextAPI.Provider>
  );
}

export default DocSearchContext;
